import {ExtraReducer, ReducerFromState} from "../../../@types/reducers";
import {ExtraSettingsObject} from "../../../@types/response";

export const getSettings = (state: ReducerFromState<ExtraReducer>): ExtraSettingsObject => state.extra.settings;